import * as Utils_String from "VSS/Utils/String";
import { Node } from "Presentation/Scripts/TFS/Stores/TreeStore";
import {WikiPage} from "TFS/Wiki/Contracts";
import {combinePaths} from "VersionControl/Scripts/VersionControlPath";
import { TemplateConstants } from "Wiki/Scripts/CommonConstants";

export function treeNodeSortOrderDecider(parentPath: string, page1: Node | string, page2: Node | string, allPages: IDictionaryStringTo<WikiPage>): number {
    const page1Title = page1 instanceof Node ? page1.name : page1;
    const page2Title = page2 instanceof Node ? page2.name : page2;
    let page1FullPath: string = "";
    let page2FullPath: string = "";

    if (parentPath || page1Title) {
        page1FullPath = combinePaths(parentPath, page1Title);
    }

    if (parentPath || page2Title) {
        page2FullPath = combinePaths(parentPath, page2Title);
    }

    const sortOrder1 = calculatedSortOrderForHandlingIncludes(allPages[page1FullPath] || {} as WikiPage);
    const sortOrder2 = calculatedSortOrderForHandlingIncludes(allPages[page2FullPath] || {} as WikiPage);

    if (sortOrder1 === sortOrder2) {
        return Utils_String.localeIgnoreCaseComparer(page1Title, page2Title);
    }

    return sortOrder1 - sortOrder2;
}

export function filteredTreeNodeCompactModeDecider(node: Node, depth: number, allFilteredPaths: IDictionaryStringTo<boolean>): boolean {
    if (depth == 0) {
        return false;
    }

    if (!node) {
        return true;
    }
    
    // don't compact the node if it contains the matching text.
    if (node.name && allFilteredPaths[node.name]) {
        return false;
    }

    // don't compact the node, if it has items
    if (node.itemCount() > 0) {
        return false;
    }

    // don't compact the node if its sub folders contains the matching text
    if (node.folderCount() > 0) {
        return node.folders.every(subNode => !allFilteredPaths[subNode.name]);
    }

    return true;
}

/**
 * WikiPage.Order contains positive integer values.
 * But we want to display templates folder at second number, independent of the order.
 * So multiple every order by 2. Such that {0, 1, 2, 3, 4, 5...} will become {0, 2, 4, 6, 8...}.
 * And assign template path order of 1.
 */
function calculatedSortOrderForHandlingIncludes(wikiPage: WikiPage): number {
    if (wikiPage.path == TemplateConstants.TemplateDirectory) {
        return 1;
    }

    return wikiPage.order != undefined
        ? 2 * wikiPage.order
        : Number.MAX_SAFE_INTEGER;
}